import axios from 'axios';

export const fetchStates = async (countryCode) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver_next_wordpress/v1/states`,
      { params: { cc: countryCode } }
    );
    return response.data || {};
  } catch (error) {
    console.error("Error fetching states:", error);
    return {};
  }
};

export const fetchCities = async (countryCode) => {
  try {
    const response = await axios.get(
      `${process.env.NEXT_PUBLIC_WORDPRESS_SITE_URL}wp-json/beaver-next-shipping-area/v1/cities`,
      { params: { cc: countryCode } }
    );
    return response.data || [];
  } catch (error) {
    console.error("Error fetching cities:", error);
    return [];
  }
};

export const fetchStreets = async (externalId) => {
  try {
    const response = await axios.get(
      `https://data.gov.il/api/3/action/datastore_search`,
      {
        params: {
          resource_id: "a7296d1a-f8c9-4b70-96c2-6ebb4352f8e3",
          q: externalId,
          include_total: false,
        },
      }
    );

    const streetOptions = response.data.result.records
      .filter(record => !/סמ\d+/g.test(record["שם_רחוב"]))
      .map((record, index) => ({
        id: index,
        name: record["שם_רחוב"].trim(),
      }))
      .sort((a, b) => a.name.localeCompare(b.name, 'he'));

    return streetOptions;
  } catch (error) {
    console.error("Error fetching streets:", error);
    return [];
  }
};